/** @import Address from '@/classes/facturae/Address' */
/** @import ContactDetails from '@/classes/facturae/ContactDetails' */
export default class AdminsitrativeCentre {
  /** @type {string?} */ CentreCode = null
  /** @type {string?} */ RoleCode = null
  /** @type {string?} */ Name = null
  /** @type {string?} */ FirstSurname = null
  /** @type {string?} */ SecondSurname = null
  /** @type {Address?} */ Address = null
  /** @type {ContactDetails?} */ ContactDetails = null
  /** @type {string?} */ PhysicalIGLN = null
  /** @type {string?} */ LogicalOperationalPoint = null
  /** @type {string?} */ CentreDescription = null
}
